export default __webpack_public_path__ + "static/media/Igel.eff423e3.webp";